<template>
  <div class="golive">
    <el-form :model="obj">
      <el-form-item label="原始值:">
        <el-input type="text" v-model="obj.originalVal" disabled></el-input>
      </el-form-item>
      <el-form-item type="text"  label="md5转换值:">
        <el-input v-model="obj.md5Val" disabled></el-input>
      </el-form-item>
      <div class="red">请参考md5转换值和auth_token是否相等</div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    registData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      obj: {
        originalVal: "", // 原始值
        md5Val: "" // md5转换值
      }
    };
  },

  methods: {
    // 获取信息
    getData() {
      this.obj.originalVal = this.registData.nowtTme + this.registData.registuser + this.registData.user_id;
      this.obj.md5Val = this.$md5(this.obj.originalVal);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input {
  width: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/liveList/attentionSet/registUsertoken.vue